import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('General');

export const PERSONCATEGORY_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.PersonCategory.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
];

export const PERSONCATEGORY_CONFIG = {
  entityName: 'PersonCategory',
  localizationKey: 'General::Entity.PersonCategory',
  fields: PERSONCATEGORY_FIELDS,
  permission: 'ControllingStructural.PersonCategories',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Structural + MENU_NAME_SUFFIX,
};
